import { getPriceInNumberDataType } from '../../utils/dataModificaionUtil';

export const getTotalBilledItemsPrice = (billedItems, considerOnlyUnitPrice) =>
    billedItems && billedItems.length > 0
        ? billedItems.every(
              (item) =>
                  (item.usedQuantity || item.otherQuantity) && item.unitPrice
          )
            ? billedItems.reduce((prev, curr) => {
                  let extPrice = 0;
                  const quantity = parseInt(
                      curr.usedQuantity || curr.otherQuantity
                  );
                  const unitPrice =
                      curr.unitPrice &&
                      getPriceInNumberDataType(curr.unitPrice);
                  const overriddenPrice =
                      curr.overrideUnitPrice &&
                      getPriceInNumberDataType(curr.overrideUnitPrice);
                  if (quantity >= 0 && unitPrice >= 0) {
                      extPrice =
                          quantity *
                          (overriddenPrice >= 0 && !considerOnlyUnitPrice
                              ? overriddenPrice
                              : unitPrice);
                  }
                  return prev + extPrice;
              }, 0)
            : 0
        : 0;

export const getTotalNonTissueItemsQty = (billedItems) =>
    billedItems && billedItems.length > 0
        ? billedItems
              .filter((item) => item.salesOrg !== 'S030')
              .reduce((acc, curr) => {
                  const ntQty = parseInt(
                      curr.usedQuantity || curr.otherQuantity
                  );
                  return !isNaN(ntQty) ? ntQty + acc : 0;
              }, 0)
        : 0;

export const getTotalExtendedPriceOfNonTissueItems = (
    billedItems,
    isOriginalPrice
) =>
    billedItems &&
    billedItems.length > 0 &&
    billedItems.filter((item) => item.salesOrg !== 'S030').length > 0
        ? getTotalBilledItemsPrice(
              billedItems.filter((item) => item.salesOrg !== 'S030'),
              isOriginalPrice
          )
        : 0;

export const getTotalTissueItemsQty = (billedItems) =>
    billedItems && billedItems.length > 0
        ? billedItems
              .filter((item) => item.salesOrg === 'S030')
              .reduce((acc, curr) => {
                  const tQty = parseInt(
                      curr.usedQuantity || curr.otherQuantity
                  );
                  return !isNaN(tQty) ? tQty + acc : 0;
              }, 0)
        : 0;

export const getTotalExtendedPriceOfTissueItems = (
    billedItems,
    isOriginalPrice
) =>
    billedItems &&
    billedItems.length > 0 &&
    billedItems.filter((item) => item.salesOrg === 'S030').length > 0
        ? getTotalBilledItemsPrice(
              billedItems.filter((item) => item.salesOrg === 'S030'),
              isOriginalPrice
          )
        : 0;
